import React from 'react';
import Icon from 'common/components/IconFont';
import { Form, Cascader, Select, Input } from 'antd';
import Button from 'common/components/Button';
import { type FormInstance } from 'antd/lib/form';
import RangePicker from '../RangePicker';
import User from '../User';
const InputGroup = Input.Group;
const Option = Select.Option;

interface iProps {
    filterConfigs?: any;
    searchParams?: any;
    onSearchChange?: Function;
    extension?: (value: { setFieldsValue: Function; setReset: Function; reinitialize: Function }) => any;
    disabledAll?: boolean;
    callbacks?: any;
    style?: any;
    onFinishFailed?: Function;
}
export default class FilterBar extends React.Component<iProps> {
    state = {
        dateSelectValue: {},
    };

    defaultValue = this.props.searchParams;
    form = React.createRef<FormInstance>();

    conversionValues = (type: 'form' | 'search', values: any) => {
        const result = { ...values };

        if (type === 'search') {
            const { inputValue } = values;

            // 格式化日期搜索组件数据
            Object.keys(values).forEach((val: string) => {
                if (val.includes('dateSelect/')) {
                    if (values[val]) {
                        if (val.split('/')[1]) result[val.split('/')[1]] = values[val][0];
                        if (val.split('/')[2]) result[val.split('/')[2]] = values[val][1];
                    }
                    delete result[val];
                }
            });

            result.inputValue = inputValue ? inputValue.replace(/(^\s*)|(\s*$)/g, '') : '';
        } else {
            const { left = [], right = [] } = this.props.filterConfigs;
            const dateSelectConfs: any = [...left, ...right].filter((item) => item.type === 'dateSelect');

            if (dateSelectConfs?.length) {
                dateSelectConfs.forEach((conf: any) => {
                    result[`dateSelect/${conf?.start}/${conf?.end}`] = [result[conf?.start], result[conf?.end]];
                    delete result[conf?.start];
                    delete result[conf?.end];
                });
            }
        }

        return result;
    };

    setFieldsValue = (values: any) => {
        this.form.current.setFieldsValue(this.conversionValues('form', values));
    };

    // 提交表单且数据验证成功后回调事件
    onFinish = () => {
        const values = this.form.current.getFieldsValue();
        const { onSearchChange } = this.props;
        onSearchChange(
            this.conversionValues('search', {
                ...values,
                ...this.state.dateSelectValue,
            }),
        );
    };

    // 提交表单且数据验证失败后回调事件
    onFinishFailed = ({ values, errorFields, outOfDate }: any) => {
        const { onFinishFailed } = this.props;
        if (onFinishFailed) onFinishFailed(this.conversionValues('search', values), errorFields, outOfDate);
    };

    // 字段值更新时触发回调事件
    onValuesChange = (_changedValues: any, allValues: any) => allValues;

    // 下拉框事件处理
    handleSelect =
        (name: string, callback: Function, conf: any = {}) =>
        (value: any) => {
            const isServerSelect =
                conf.key &&
                ['server', 'serverId', 'server_id'].includes(conf.key) &&
                conf.options?.find(({ value: val }: any) => value === val);
            if (isServerSelect) window.localStorage.setItem('defaultServer', value);
            this.setState({ [name]: value });
            if (callback) callback({ [name]: value }, this.setFieldsValue);
        };

    normalizeInput = (value: any, inputType: string) => {
        return ['uemail', 'email', 'sales_email', 'agent_email'].includes(this.form.current.getFieldValue(inputType))
            ? value.toLowerCase()
            : value;
    };

    // 查询重置处理
    handleReset = () => {
        const { onSearchChange } = this.props;
        this.setFieldsValue(this.defaultValue);
        onSearchChange(this.defaultValue);
    };

    // 重新初始化数据
    reinitialize = (value: any) => {
        this.setFieldsValue(value);
        this.defaultValue = value;
    };

    // 导出模态框控制
    exportHandler = (callback: Function) => {
        callback(
            this.conversionValues('search', {
                ...this.form.current?.getFieldsValue(),
                ...this.state.dateSelectValue,
            }),
        );
    };

    handleChangeDate = (config: any, value: any) => {
        this.setState({
            dateSelectValue: {
                [`dateSelect/${config.start}/${config.end}`]: value,
            },
        });
    };

    componentDidMount() {
        const { extension } = this.props;
        if (extension)
            extension({
                setFieldsValue: this.setFieldsValue,
                setReset: this.handleReset,
                reinitialize: this.reinitialize,
            });
    }

    render() {
        const { left, right } = this.props.filterConfigs;
        const { disabledAll } = this.props;
        const elementGenerator = (conf: any, index: number) => {
            conf.disabled = disabledAll || conf.disabled;
            conf.locker = disabledAll || conf.locker;
            // 如果有服务器选择 且下拉项未获取 禁用提交按钮
            const serverConf = left
                ?.filter(Boolean)
                .find((conf: any) => conf.key && ['server', 'serverId', 'server_id'].includes(conf.key));
            const submitDisable = serverConf && !serverConf.options?.length;
            switch (conf.type) {
                case 'dateSelect':
                    return (
                        <Form.Item key={index} name={`dateSelect/${conf.start}/${conf.end}`}>
                            <RangePicker
                                key={index}
                                defaultDate={
                                    this.defaultValue[conf.start] && this.defaultValue[conf.end]
                                        ? [this.defaultValue[conf.start], this.defaultValue[conf.end]]
                                        : ''
                                }
                                disabledDate={conf.disabledDate}
                                lang={conf.lang}
                                onDateChange={(val) => {
                                    this.handleChangeDate(conf, val);
                                }}
                                showTime={conf.showTime}
                                disabledRanges={conf.disabledRanges}
                                extraRanges={conf.extraRanges}
                                disabledDateRange={conf.disabledDateRange}
                                disabled={conf.disabled}
                            />
                        </Form.Item>
                    );
                case 'select':
                    return (
                        <Form.Item key={index} name={conf.key}>
                            <Select
                                style={
                                    conf.style || {
                                        minWidth: 150,
                                        width: 'auto',
                                    }
                                }
                                placeholder={conf.placeholder}
                                disabled={conf.disabled}
                                onChange={this.handleSelect(conf.key, conf.callback, conf)}
                                showSearch={Array.isArray(conf.options) && conf.options.filter(Boolean).length > 10}
                                filterOption={(input: string, option: any) => {
                                    const text = option.props.children;
                                    return (typeof text === 'string' ? text : text[0])
                                        .toLowerCase()
                                        .includes(input.toLowerCase());
                                }}
                            >
                                {conf.options.map((opt: any, index: number) => {
                                    return (
                                        <Option value={opt.value} title={opt.text} key={index} disabled={opt.disabled}>
                                            {opt.text}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    );
                case 'input':
                    return (
                        <Form.Item key={index} name={conf.key}>
                            <Input
                                placeholder={conf.placeholder}
                                style={{ width: 150 }}
                                name={conf.key}
                                disabled={conf.disabled}
                                onPressEnter={() => this.onFinish}
                            />
                        </Form.Item>
                    );
                case 'textarea':
                    return (
                        <Form.Item key={index} name={conf.key}>
                            <textarea
                                placeholder={conf.placeholder}
                                style={{
                                    width: '100%',
                                    height: 174,
                                    resize: 'none',
                                    marginBottom: '10px',
                                    borderRadius: '4px',
                                    border: 'solid 1px #bebebe',
                                    padding: '8px 0 0 10px',
                                    backgroundColor: '#fefefe',
                                }}
                                name={conf.key}
                                disabled={conf.disabled}
                                onSubmit={this.onFinish}
                            />
                        </Form.Item>
                    );
                case 'selectInput':
                    return (
                        <Form.Item key={index}>
                            <InputGroup compact style={{ display: 'inline-block' }}>
                                <Form.Item name={conf.selectKey} style={{ display: 'inline-block' }}>
                                    <Select
                                        className="search-select"
                                        style={{ width: 130, marginRight: 0 }}
                                        onChange={this.handleSelect(conf.selectKey, conf.callback)}
                                        disabled={conf.disabled}
                                    >
                                        {conf.options.map((opt: any) => {
                                            return (
                                                <Option
                                                    value={opt.value}
                                                    key={opt.value}
                                                    title={opt.text}
                                                    disabled={opt.disabled}
                                                >
                                                    {opt.text}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name={conf.inputKey}
                                    normalize={(value: any) => this.normalizeInput(value, conf.selectKey)}
                                    style={{ display: 'inline-block' }}
                                >
                                    <Input
                                        placeholder={conf.placeholder}
                                        style={{ width: 200 }}
                                        disabled={conf.disabled}
                                        onPressEnter={() => this.onFinish}
                                    />
                                </Form.Item>
                            </InputGroup>
                        </Form.Item>
                    );

                // Wrapped in Form.Item so the value flows through getFieldsValue() on submit and
                // resets back to searchParams on reset — the previously commented-out version rendered
                // a bare Cascader whose value never reached either path.
                // 必须包在 Form.Item 里：提交时值才会进 getFieldsValue()，重置时才会回落到 searchParams。
                // The 8px gutter every other control gets comes from style.less matching its inner class
                // (`.ant-select`, `.ant-picker`, …); the list there still names the antd v3 `.ant-cascader-picker`,
                // so nothing matches a v4 Cascader. Put the gutter on the Form.Item instead of the inner control:
                // the Form.Item is the direct flex child of `.Filter-barLeft`, and `.Filter-bar .ant-form-item`
                // only sets margin-bottom — so this lands regardless of which class the inner control ends up with.
                // 其它控件的 8px 间距来自 style.less 对内部类名（.ant-select / .ant-picker …）的匹配，而那份列表里
                // 写的还是 antd v3 的 .ant-cascader-picker，v4 的 Cascader 命中不了。间距改加在 Form.Item 上：
                // 它是 .Filter-barLeft 这个 flex 容器的直接子元素，且 .Filter-bar .ant-form-item 只设了
                // margin-bottom，所以不依赖内部控件最终带什么类名。
                case 'cascader':
                    return (
                        <Form.Item key={index} name={conf.key} style={{ marginRight: 8 }}>
                            <Cascader
                                style={conf.style || { minWidth: 200 }}
                                options={conf.options}
                                loadData={conf.loadData}
                                placeholder={conf.placeholder}
                                disabled={conf.disabled}
                                allowClear={conf.allowClear}
                                changeOnSelect={conf.changeOnSelect}
                                displayRender={conf.displayRender}
                                // showSearch only filters options already present in `options` —
                                // with lazy `loadData` the unexpanded branches are not searchable.
                                // showSearch 只在已加载的 options 上过滤；配合 loadData 时未展开的层级搜不到。
                                showSearch={conf.showSearch}
                                // Caps each dropdown column so long names don't push the menu off-screen
                                // 限制下拉每列宽度，避免超长姓名把菜单撑出屏幕
                                dropdownMenuColumnStyle={conf.dropdownMenuColumnStyle}
                            />
                        </Form.Item>
                    );
                case 'submit':
                    return (
                        <Button
                            type="primary"
                            ghost={conf.ghost}
                            key={index}
                            htmlType="submit"
                            disabled={conf.locker || submitDisable}
                            className="btn-submit"
                        >
                            {conf.text}
                        </Button>
                    );
                case 'reset':
                    return (
                        <Button
                            type="primary"
                            ghost={conf.ghost}
                            key={index}
                            onClick={this.handleReset}
                            disabled={conf.locker}
                            className="btn-reset"
                        >
                            {conf.text}
                        </Button>
                    );
                case 'btn':
                    return (
                        <Button
                            type="primary"
                            ghost={conf.ghost}
                            key={index}
                            onClick={conf.callback}
                            disabled={conf.locker}
                        >
                            {conf.text}
                        </Button>
                    );
                case 'icon':
                    return (
                        <Button
                            shape="circle"
                            key={index}
                            icon={<Icon className={`anticon-${conf.icon}`} />}
                            disabled={conf.locker}
                            onClick={conf.callback}
                        />
                    );
                case 'iconBtnSubmit':
                    return (
                        <Button key={index} icon={<Icon type={conf.icon} />} disabled={conf.locker} htmlType="submit" />
                    );
                case 'custom':
                    return React.cloneElement(conf.render, { key: index });
                case 'export':
                    return (
                        <Button
                            type="primary"
                            ghost={conf.ghost}
                            key={index}
                            onClick={() => {
                                this.exportHandler(conf.callback);
                            }}
                            disabled={conf.locker}
                            className="btn-submit"
                        >
                            {conf.text}
                        </Button>
                    );
                case 'selectSearch':
                    return (
                        <Form.Item key={index}>
                            <InputGroup compact style={{ display: 'inline-block' }}>
                                <Form.Item name={conf.selectKey}>
                                    <Select
                                        className="search-select"
                                        style={{ width: 130, marginRight: 0 }}
                                        onChange={this.handleSelect(conf.selectKey, conf.callback)}
                                        disabled={conf.disabled}
                                    >
                                        {conf.options.map((opt: any) => {
                                            return (
                                                <Option
                                                    value={opt.value}
                                                    key={opt.value}
                                                    title={opt.text}
                                                    disabled={opt.disabled}
                                                >
                                                    {opt.text}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <User
                                        placeholder={conf.placeholder}
                                        style={{ width: 200 }}
                                        normalizeInput={this.normalizeInput}
                                        disabled={conf.disabled}
                                        onSelect={conf.onSelect}
                                        inputKey={conf.inputKey}
                                        onPressEnter={() => this.onFinish}
                                        callback={
                                            conf.callbacks[
                                                this.form.current
                                                    ? this.form.current.getFieldsValue()[conf.selectKey]
                                                    : this.defaultValue[conf.selectKey]
                                            ]
                                        }
                                        filter={conf.filter}
                                        initialValue={this.defaultValue[conf.inputKey]}
                                        showUuid={conf.showUuid}
                                        role={conf.role}
                                    />
                                </Form.Item>
                            </InputGroup>
                        </Form.Item>
                    );

                case 'cascaderSearch':
                    return (
                        <Form.Item key={index}>
                            <InputGroup compact style={{ display: 'inline-block' }}>
                                <Form.Item name={conf.selectKey}>
                                    <Cascader
                                        className="search-cascader"
                                        style={{ width: 130, marginRight: 0 }}
                                        options={conf.options}
                                        loadData={conf.loadData}
                                        onChange={this.handleSelect(conf.selectKey, conf.callback)}
                                        disabled={conf.disabled}
                                        placeholder={conf.placeholder}
                                        allowClear={conf.allowClear}
                                        changeOnSelect={conf.changeOnSelect}
                                    />
                                </Form.Item>
                                <User
                                    placeholder={conf.placeholder}
                                    style={{ width: 200 }}
                                    normalizeInput={this.normalizeInput}
                                    disabled={conf.disabled}
                                    onSelect={conf.onSelect}
                                    inputKey={conf.inputKey}
                                    callback={
                                        conf.callbacks[
                                            this.form.current
                                                ? this.form.current.getFieldsValue()[conf.selectKey]
                                                : this.defaultValue[conf.selectKey]
                                        ]
                                    }
                                    showUuid={conf.showUuid}
                                    filter={conf.filter}
                                    initialValue={this.defaultValue[conf.inputKey]}
                                    role={conf.role}
                                    serverId={conf.serverId}
                                />
                            </InputGroup>
                        </Form.Item>
                    );

                case 'cascaderInput':
                    return (
                        <Form.Item key={index}>
                            <InputGroup compact style={{ display: 'inline-block' }}>
                                <Form.Item name={conf.selectKey}>
                                    <Cascader
                                        className="search-cascader"
                                        style={{ width: 130, marginRight: 0 }}
                                        options={conf.options}
                                        loadData={conf.loadData}
                                        onChange={this.handleSelect(conf.selectKey, conf.callback)}
                                        disabled={conf.disabled}
                                        placeholder={conf.placeholder}
                                        allowClear={conf.allowClear}
                                        changeOnSelect={conf.changeOnSelect}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name={conf.inputKey}
                                    normalize={(value: any) => this.normalizeInput(value, conf.inputKey)}
                                >
                                    <Input
                                        placeholder={conf.placeholder}
                                        style={{ width: 200 }}
                                        disabled={conf.disabled}
                                        onPressEnter={() => this.onFinish}
                                    />
                                </Form.Item>
                            </InputGroup>
                        </Form.Item>
                    );

                default:
                    return null;
            }
        };

        return (
            <Form
                name="complex-form"
                className="Filter-bar"
                initialValues={this.conversionValues('form', this.defaultValue)}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                onValuesChange={this.onValuesChange}
                ref={this.form}
            >
                <div className="Filter-barLeft">{left?.map(elementGenerator)}</div>
                <div className="Filter-barRight flex items-center">{right?.map(elementGenerator)}</div>
            </Form>
        );
    }
}
